import https from "../utils/http";
import {searchPot} from '@/api/apiPot'
var dayjs = require('dayjs')
//
/**
 *  商品相关接口
 */

/** 获取商品分类 */
export function getCategory(params) {
  return https.get(`goods/category`, params);
}

/** 获取筛选-分类列表-一级 */
export function getScreenCategory(params) {
  return https.get(`/goods/screenCategoryTop`, params);
}
/** 获取筛选-分类列表-其他级 */
export function getScreenCategoryOther(params) {
  return https.get(`/goods/getScreenCategoryOther`, params);
}
/** 获取筛选-剂型首次加载数据 */
export function getScreenDosageForm(params) {
  return https.get(`/goods/getScreenDosageForm`, params);
}
/** 获取筛选-商品规格数据筛选 */
export function getSpecification(params) {
  return https.get(`/goods/getSpecification`, params);
}
const  getSearch=(item)=>{
  if(!item.keywords) return
  const start = dayjs().format('YYYY-MM-DD HH:mm:ss')
  searchPot({ keyword_info: item.keywords, type: item.type||'', login_device: 3, ip: localStorage.getItem('ipAddress'), start_time:  start}).then(res => {

  }).catch(err => {  });
}
/** 获取商品列表 */
export function getGoodsList(params) {
  getSearch(params)
  // delete params.type
  return https.get(`goods/index`, params);
}

/** 商品搜索 */
export function getGoodsSearch(params) {
  return https.get(`goods/search`, params);
}
/** 商品详情 */
export function getGoodsDetail(params) {
  return https.get(`goods/read`, params);
}
/** 商品一周销量排行榜 */
export function getGoodsSaleTop(params) {
  return https.get(`goods/saleTop`, params);
}
/** 商品详情预览页 */
export function getGoodsDetailPreview(params) {
  return https.get(`index/preview_read`, params);
}
/** 商品详情预览页——一周销量排行榜 */
export function getGoodsSaleTopPreview(params) {
  return https.get(`/index/preview_saleTop`, params);
}
/** 购物车列表*/
export function getGoodsCart(params) {
  return https.get(`GoodsCart/index`, params);
}
/** 添加普通购物车*/
export function addGoodsCart(params) {
  return https.post(`GoodsCart/add`, params);
}
/** 编辑普通购物车*/
export function updateGoodsCart(params) {
  return https.post(`GoodsCart/edit`, params);
}
/** 删除普通购物车*/
export function delGoodsCart(params) {
  return https.post(`GoodsCart/delete`, params);
}
/** 勾选普通购物车*/
export function selectedCart(params) {
  return https.post(`GoodsCart/selection`, params);
}
/** 我的收藏勾选普通购物车*/
export function addAllGoodsCart(params) {
  return https.post(`/GoodsCart/addMore`, params);
}
/** 确认订单*/
export function confirmOrder(params) {
  return https.post(`Order/confirmOrder`, params);
}
/** 提交订单*/
export function submitOrder(params) {
  return https.post(`Order/submitOrder`, params);
}
/** 获取支付渠道*/
export function paymentChannels(params) {
  return https.post(`Order/paymentChannels`, params);
}
/** 提交支付*/
export function pcpayinfo(params) {
  return https.post(`yiPay/yipcpay`, params);
}
/** 提交支付（优惠券）*/
export function pcpayinfoForCoupon(params) {
  return https.post(`yiPay/yipcpayForCoupon`, params);
}
/** pc轮询查询支付状态*/
export function getPayStatus(params) {
  return https.post(`Notify/order_success`, params);
}
/** pc轮询查询优惠券订单支付状态*/
export function getCouponPayStatus(params) {
  return https.post(`Notify/coupon_order_success`, params);
}
/** 商品收藏*/
export function collection(params) {
  return https.get(`help/collection`, params);
}
/** 新人特价列表 */
export function getXrtjGoodsList(params) {
  return https.get(`goods/xrtj`, params);
}
/** 再次购买加入购物车 */
export function addbuyAgain(params) {
  return https.post(`Order/buyAgain`, params);
}
/** 秒杀加入购物车 */
export function goodAddSkill(params) {
  return https.post(`GoodsCart/addSkill`, params);
}
/** 套餐加入购物车 */
export function goodAddPackage(params) {
  return https.post(`GoodsCart/addPackage`, params);
}
/** 获取组合套餐商品列表 */
export function getPackageList(params) {
  return https.get(`/goods/package_list`, params);
}
/** 获取单品包邮商品列表 */
export function getFreeList(params) {
  return https.get(`/goods/free_shipping`, params);
}
/** 医治学验证用户token是否过期 */
export function YZXList(params) {
  return https.get(`/YiZiXue/GetList`, params);
}

/** 购物车弹窗列表 */
export function goodscollectGoods(params) {
  return https.get(`/goods/collectGoods`, params);
}

/** 购物车弹窗列表 */
export function GoodsCartAddCollectGoods(params) {
  return https.post(`/GoodsCart/addCollectGoods`, params);
}




// WEBPACK FOOTER //
// ./src/api/goods.js